import React from 'react';
import { motion } from 'framer-motion';
export function Production() {
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/9iW4zKHF6BLtzvfoDLnLQ9/CARRIER_SWIFT.png',
    caption: 'Logistics & Moving Companies',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/u2RgjUaZAe5uhguq2pGNkL/Electric_Full_Color.png',
    caption: 'Electricians & Contractors',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/33jSVaGGEpBw8KTGwkJ5cx/ELECTRICOI.png',
    caption: 'Commercial & Residential Electric',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/2pojmkvACoj5qZeoY3ojS9/BBQ_PITMASTER.png',
    caption: 'Restaurants & BBQ',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/kwa6gexaiQToZhf2WM5zLF/ELECTRICIAN_NAVY.png',
    caption: 'Electrical Contractors',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/q9619cMu2XcLmjKc2wAqRd/PACHECOS_CONCRETE_FULL_COLOR.png',
    caption: 'Concrete & Masonry',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/pDd63H2qdaPM8hDjPLojto/I_CAN_HELP.png',
    caption: 'Nonprofits & Community Teams',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/iKyeqiENA4j6FSnnfATY74/MEXICAN_WORKER.png',
    caption: 'Construction Crews',
    position: 'center'
  }];
  return <section id="work" className="scroll-mt-24 pt-24 pb-12 bg-white" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-112">
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-113">
            See How We Make Your Apparel
          </h2>
          <div className="w-24 h-2 bg-black mx-auto" data-id="element-114"></div>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-id="element-115">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index % 4 * 0.1
        }} className="group relative overflow-hidden border-2 sm:border-4 border-black bg-gray-100" data-id="element-116">
              <div className="w-full aspect-[3/4] sm:aspect-[4/5]" data-id="element-117">
                <img src={img.url} alt={img.caption} style={{
              objectPosition: img.position
            }} className="w-full h-full object-cover filter grayscale-0 group-hover:grayscale transition-all duration-500" data-id="element-118" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-black text-white px-2 py-2 sm:px-3 sm:py-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-119">
                <p className="font-display font-bold uppercase tracking-wider text-xs sm:text-sm text-center leading-tight" data-id="element-120">
                  {img.caption}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}